/**
 * Labstep
 *
 * @module components/Resource/Preview
 * @desc Preview for resource
 */

import { EntityPreview } from 'labstep-web/components/Entity/Preview';
import { MetadataManagerContainer as MetadataManager } from 'labstep-web/components/Metadata/Manager';
import {
  Action,
  ResourceActionMenu,
} from 'labstep-web/components/Resource/Action/Menu';
import { ResourceTemplatePreview } from 'labstep-web/components/ResourceTemplate/Preview';
import type React from 'react';
import type {
  IResourcePreviewManagerProps,
  IResourcePreviewProps,
} from './types';

export const ResourcePreview: React.FC<IResourcePreviewProps> = ({
  resource,
  ...rest
}) => (
  <EntityPreview
    actionMenu={
      <ResourceActionMenu
        resource={resource}
        actions={[
          Action.set_resource_template,
          Action.tag,
          Action.create_order_request,
          Action.share,
          Action.duplicate,
          Action.delete,
          Action.transfer_ownership,
        ]}
      />
    }
    entity={resource}
    secondaryInfo={<MetadataManager entity={resource} />}
    {...rest}
  />
);

export const ResourcePreviewManager: React.FC<
  IResourcePreviewManagerProps
> = ({ resource, ...rest }) =>
  resource.is_template ? (
    <ResourceTemplatePreview {...rest} resource={resource} />
  ) : (
    <ResourcePreview {...rest} resource={resource} />
  );

export default ResourcePreviewManager;
